__turbopack_context__.v({
  "terms-modal__actions": "TermsModal-module-scss-module__iaw-Oa__terms-modal__actions",
  "terms-modal__body": "TermsModal-module-scss-module__iaw-Oa__terms-modal__body",
  "terms-modal__content": "TermsModal-module-scss-module__iaw-Oa__terms-modal__content",
});
